<!-- 收货地址页面 -->
<template>
    <div>
		<van-nav-bar
		  	title="收货地址"
			left-arrow
		  	@click-left="$router.go(-1)">
		</van-nav-bar> 
		<van-field
            v-model="name"
            label="姓名"
            clearable
            placeholder="请输入姓名"
        />
        <van-field
            v-model="areaName"
            label="区号"
            readonly
            is-link
            placeholder="请选择区号"
            @click="showPicker=true"
        />
        <van-popup v-model="showPicker" position="bottom">
			<van-icon
				slot="right-icon"
				name="./static/img/ok.png"
				size="25px"
				@click="add()"
			/>
		  	<van-picker
			    show-toolbar
			    :columns="columns"
			    :confirm-button-text="$t('vantText.confirm')"
				:cancel-button-text="$t('vantText.cancel')"
			    @cancel="showPicker = false"
			    @confirm="onConfirm"
		  	/>
		</van-popup>
		<van-field
            v-model="phone"
            label="电话号码"
            clearable
            placeholder="请输入电话号码"
        >
			<!-- <van-button slot="button" size="small" type="primary" :disabled='isSms' @click="sendCode()">发送验证码</van-button> -->
		</van-field>
		<!-- <van-field
            v-model="smsCode"
            label="验证码"
            clearable
            placeholder="请输入验证码"
            @blur="verificatioCode()"
        /> -->
		<!-- 省市区 -->
		<!-- <van-field
            v-model="area_name"
            label="省市区"
            clearable
            placeholder="请输入省市区"
			is-link
			@click="showAreaList=true"
        />
		<van-popup v-model="showAreaList" position="bottom">
		  	<van-area title="标题" :area-list="areaList" @confirm='confirmAreaList' @cancel="showAreaList=false"/>
		</van-popup> -->

        <van-field
            v-model="address"
            label="地址"
            clearable
            placeholder="请输入地址"
        />
        <div style="color:red;padding-left:16px;margin-top:10px">配送超过一公里,需另外收取配送费</div>
        <!-- 下单:跳转到下单成功页面 -->
        <!-- :disabled='isDisabled' -->
		<van-button style="width: 90%;height: 35px;margin-left: 5%;margin-top: 50px;line-height: 35px;" color="#2f75f4" round @click="placeOrder()">下单</van-button>
	</div>
</template>

<script>
import AreaList from './area'; 
export default {
    data () {
        return {
			name:'',
			phone:'',
            address:'',
            showPicker:false,
            columns:[],//区号列表
            areacode:'',
            areaName:'',
            isSms:false,
            smskey:'',
			smsCode:'',//验证码
			areaList:AreaList,
			showAreaList:false,
			// 省市区
			// province:'',
			// city:'',
			// area:'',
			// area_name:'',
			isDisabled:true

        };
    },
    created(){
        this.getAreacode()
    },
    methods:{
        // 获取区号
        getAreacode(){
    		this.$axios({
                method: 'get',
                url: this.$build+'/api/areacode',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.columns=res.data.data;
                	for(var i = 0;i<this.columns.length;i++){
                		if(this.$i18n.locale=='en'){
							this.columns[i].text=this.columns[i].acname_en+'('+this.columns[i].acnumber+')';
						}else if(this.$i18n.locale=='hk'){
							this.columns[i].text=this.columns[i].acname_hk+'('+this.columns[i].acnumber+')';
						}else if(this.$i18n.locale=='zh'){
							this.columns[i].text=this.columns[i].acname_cn+'('+this.columns[i].acnumber+')';
						}else{
							this.columns[i].text=this.columns[i].acname_en+'('+this.columns[i].acnumber+')';
						}
                	}
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('common.message'),
        		});
            });
        },
        onConfirm(value,index) {
            this.areacode = this.columns[index].acnumber;
            console.log(this.areacode)
	      	this.areaName =value.text;
	      	this.showPicker = false;
        },
        // 发送验证码
        sendCode(){
			if(this.areacode&&this.phone){
				this.$axios({
	                method: 'post',
	                url: this.$build+'/api/send',
	                data:{
	                	area_code:this.areacode,
	                	phone:this.phone,
	                },
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});           	
		            	this.isSms=true;
		            	this.smskey=res.data.success.key;
		            	const vm=this;
		            	setTimeout(function(){
		            		vm.isSms=false;
		            	},60000);
	            	}else{
	            		this.$toast({
							type:'fail',
							message:res.data.message,
						});
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('common.message'),
            		});
	            });
			}else{
				this.$toast('请填写完整信息');
			}
        },
        // 验证验证码
        verificatioCode(){
            if(this.smsCode){
                this.$axios({
                method: 'post',
                url: this.$build+'/api/verification',
                data:{
                    key:this.smskey,
                    code:this.smsCode
                }
                }).then(res => {
                    console.log(res);
                    if(res.data.status==200){
                        this.isDisabled = false;
                    }else{
                        for (var item in res.data.error) {
                            this.$toast({
                                type:'fail',
                                message:res.data.error[item],
                            });
                        }
                    }
                }).catch(err => {
                    this.$toast({
                        type:'fail',
                        message:this.$t('common.message'),
                    });
                });
            }else{
                this.$toast('请填写验证码');
            }
		},
		// 省市区
		confirmAreaList(value){
			this.showAreaList = false;
			console.log(value)
			// 获取省
			this.province = value[0].name;
			// 市
			this.city = value[1].name;
			// 区
			this.area = value[2].name;
			this.area_name = this.province+this.city+this.area
			console.log(this.province+this.city+this.area)
		},
		// 下单
		placeOrder(){
			// this.verificatioCode(); //验证验证码
			// &&this.smsCode
			if(this.name&&this.areacode&&this.phone&&this.address){
				this.$axios({
					method:'PATCH',
					url:this.$build+'/api/place/takeOrder',
					data:{
						code:localStorage.onlyCode,
						store_id:sessionStorage.storeId,
						type:'2',
						name:this.name,
						area_code:this.areacode,
						phone:this.phone,
						address:this.address
					}
				}).then(res=>{
					console.log(res)
					if(res.data.status==200){
						this.$toast({
							type:'success',
							message:res.data.message,
						});
						localStorage.setItem('takeOrderId',res.data.id)
						var vm = this;
						setTimeout(()=>{
							vm.$router.push('/TakeOrderDetail/'+res.data.id)
						},500)
						
						localStorage.setItem('successCode',localStorage.onlyCode)
					}else{
						for (var item in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[item],
							});
						}
					}
				}).catch(err=>{
					this.$toast({
						type:'fail',
						message:this.$t('common.message'),
					});
				})
			}else{
				this.$toast('请填写完整信息')
			}	
		}

    }
}

</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #fff;
	}
	/deep/ .van-picker__cancel, /deep/ .van-picker__confirm{
		color: #2f75f4;
	}
</style>


// WEBPACK FOOTER //
// src/takeAway/Address.vue